// providers/SocialAuthRedirect.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function SocialAuthRedirect({ children }) {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectPath = localStorage.getItem("redirect_path");

    if (redirectPath) {
      navigate(redirectPath);
      localStorage.removeItem("redirect_path");
      return;
    }

    const tokenMatch = window.location.href.match(/access_token=([^&]+)/);
    if (tokenMatch?.[1]) {
      localStorage.setItem("token", tokenMatch[1]);
      navigate("/login", { state: false });
      return;
    }

    const code = localStorage.getItem("code");
    const state = localStorage.getItem("state");
    if (code || state) {
      navigate("/settings/social-links");
    }
  }, [navigate]);

  return children;
}
